<div class="templates-list">
  <!-- preload the image, so there is no flickering when we need to show it -->
  <link rel="preload" href="/assets/images/templates-selector/no-results.svg" as="image" />

  <cc-templates-selector-tool-bar
    [viewType]="viewType"
    [showClearFiltersBtn]="showClearFiltersBtn"
    (search)="onSearchKeyWord($event)"
    (changedViewType)="changeViewType($event)"
    (filtersCleared)="onClearFilters()"
  ></cc-templates-selector-tool-bar>

  <cc-apps-list-tab-filter
    *ngIf="!isLibrarySelection"
    [tabs]="tabs"
    [selectedTabIds]="selectedTabIds"
    (onFilter)="onFilterByTabs($event)"
    [canEdit]="false"
    [class]="viewType"
  >
  </cc-apps-list-tab-filter>

  <div class="templates-list-main">
    <div class="facets scroll-shadows" *ngIf="isLibrarySelection && !isBusinessAttributesLoading">
      <cc-business-attributes-facet
        class="verticals-facet"
        title="Industry"
        i18n-title
        [options]="verticals"
        [selectedOptions]="selectedVerticals"
        [clearFilters]="clearFilters"
        (selection)="onVerticalSelection($event)"
      >
      </cc-business-attributes-facet>
      <cc-business-attributes-facet
        class="roles-facet"
        title="Role"
        i18n-title
        [options]="roles"
        [selectedOptions]="selectedRoles"
        [clearFilters]="clearFilters"
        (selection)="onRoleSelection($event)"
      >
      </cc-business-attributes-facet>
      <cc-business-attributes-facet
        class="functions-facet"
        title="Function"
        i18n-title
        [options]="functions"
        [clearFilters]="clearFilters"
        (selection)="onFunctionSelection($event)"
      >
      </cc-business-attributes-facet>
    </div>
    <div class="flex-1 loading" *ngIf="loading; else loaded">
      <i class="mr-2 cc-icon cc-icon-spinner-2x"></i>
      <span>Loading...</span>
    </div>
  </div>

  <ng-template #loaded>
    <div class="no-visible-templates" *ngIf="!visibleTemplates?.length; else displayTemplates">
      <img alt="No templates available" src="/assets/images/templates-selector/no-results.svg" />
      <p class="default-paragraph" i18n>Oops! It appears no templates are available</p>
    </div>

    <ng-template #displayTemplates>
      <cc-templates-selector-register-view
        [visibleTemplates]="visibleTemplates"
        [isLibrarySelection]="isLibrarySelection"
        (onSelect)="onTemplateSelection($event)"
        [onSelectionChange]="onSelectionChange"
        [isSingleSelectionOnly]="isSingleSelectionOnly"
        [selectedTemplates]="selectedTemplates"
        *ngIf="viewType === templateSelectorViewTypes.Register"
      >
      </cc-templates-selector-register-view>

      <cc-templates-selector-grid-view
        [visibleTemplates]="visibleTemplates"
        [isLibrarySelection]="isLibrarySelection"
        [tabs]="tabs"
        [functions]="functions"
        [selectedTabIds]="selectedTabIds"
        [onSelectionChange]="onSelectionChange"
        (onSelect)="onTemplateSelection($event)"
        [isSingleSelectionOnly]="isSingleSelectionOnly"
        [selectedTemplates]="selectedTemplates"
        *ngIf="viewType === templateSelectorViewTypes.Grid"
      >
      </cc-templates-selector-grid-view>
    </ng-template>
  </ng-template>
</div>

<div class="templates-badges" *ngIf="!isSingleSelectionOnly">
  <span *ngIf="!selectedTemplates?.length" [class.sm-text-default-red]="!isDefaultTextColor" i18n
    >No templates selected</span
  >
  <div *ngIf="selectedTemplates?.length">
    <span i18n>Selected templates:</span>
    <span *ngFor="let template of selectedTemplates | slice : 0 : maxBadgesToDisplay" class="selected-badge"
      >{{ template.name }} <i class="cc-icon cc-icon-close-small" (click)="deselect(template)"></i
    ></span>
    <span *ngIf="selectedTemplates.length > maxBadgesToDisplay">
      and {{ selectedTemplates.length - maxBadgesToDisplay }} more</span
    >

    <a (click)="clearSelection()" class="selected-clear" i18n>clear</a>
  </div>
</div>
